<script lang="ts">
	import { Button } from '$lib/components/ui/button/index.js';
	import * as Card from '$lib/components/ui/card/index.js';
	import { isAnonymousReview } from '$lib/config/review';
	import { ExternalLink } from '@lucide/svelte';

	let { data } = $props();

	const contributionPlaceholders = [
		'TBD: core algorithm design and formulation',
		'TBD: implementation and integration',
		'TBD: experiments, benchmarking, and validation',
		'TBD: writing, figures, and presentation'
	];
</script>

<svelte:head>
	<title>{isAnonymousReview ? 'SEW Geometric Teleop' : 'SEW Geometric Teleop | Authors'}</title>
</svelte:head>

<main class="container mx-auto py-12 px-6 space-y-16">
	{#if isAnonymousReview}
		<div class="mx-auto max-w-2xl space-y-4 text-center">
			<h1 class="text-2xl font-semibold tracking-tight text-foreground">
				Author information omitted
			</h1>
			<p class="text-muted-foreground">
				Author and affiliation details are omitted for anonymous review.
			</p>
		</div>
	{:else}
		<div class="text-center mx-auto">
			<!-- <h1 class="text-4xl font-bold tracking-tighter sm:text-5xl md:text-6xl text-foreground">Authors</h1> -->
			<p class="mt-4 text-muted-foreground md:text-xl whitespace-nowrap overflow-hidden text-ellipsis px-4">
				This work would not have been possible without the invaluable contributions from everyone listed here.
			</p>
		</div>

		{#each Object.entries(data.authorGroups) as [groupName, groupAuthors] (groupName)}
			<section class="space-y-6">
				<h2 class="text-2xl font-bold tracking-tight border-l-4 border-primary pl-4 text-foreground/90">{groupName}</h2>
				<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
					{#each groupAuthors as author (author.name)}
						<Card.Root class="flex flex-col h-full bg-card/60 hover:bg-card/90 transition-all hover:shadow-lg hover:-translate-y-1 border-muted overflow-hidden group">
							<!-- Header Section -->
							<div class="p-5 flex items-start gap-4">
								<img
									src={author.imageUrl}
									alt={`${author.name}`}
									class="h-20 w-20 rounded-full object-cover ring-2 ring-border/50 bg-muted shrink-0 group-hover:ring-primary/50 transition-all"
									loading="lazy"
									decoding="async"
								/>
								<div class="flex-1 min-w-0 flex flex-col items-start">
									<h3 class="font-bold text-base leading-tight truncate w-full" title={author.name}>{author.name}</h3>
									<div class="flex items-center justify-between w-full mt-1">
										<p class="text-[10px] uppercase tracking-wider font-semibold text-muted-foreground line-clamp-2 pr-2 leading-snug">{author.title}</p>
										<Button
											variant="ghost"
											size="icon"
											href={author.website}
											target="_blank"
											rel="noopener noreferrer"
											class="h-6 w-6 -mr-2 text-muted-foreground hover:text-primary transition-colors"
											title="Visiting Website"
										>
											<ExternalLink class="h-3.5 w-3.5" />
										</Button>
									</div>
								</div>
							</div>

							<!-- Contributions Section -->
							{#if groupName !== 'Advising'}
								<div class="rounded-md bg-muted/30 p-4 flex-grow">
									<ul class="space-y-2 text-muted-foreground/80 text-xs">
										{#each (author.contributions && author.contributions.length > 0 ? author.contributions : contributionPlaceholders) as item}
											<li class="flex items-start gap-2 leading-relaxed">
												<span class="mt-1 h-1 w-1 rounded-full bg-primary/40 shrink-0"></span>
												<span>{item}</span>
											</li>
										{/each}
									</ul>
								</div>
							{/if}
						</Card.Root>
					{/each}
				</div>
			</section>
		{/each}
	{/if}

	<div class="text-center pt-8 border-t">
		<Button variant="outline" size="lg" href="/">Back to demo</Button>
	</div>
</main>
